import ApplicationError from 'app/models/request/ApplicationError';

// Oauth error codes.
export const INVALID_GRANT = 'invalid_grant';
export const INVALID_SCOPE = 'invalid_scope';

// Custom error codes.
export const DESERIALIZATION_LOCK_FAILURE     = 'DeserializationError.LockFailure';
export const DESERIALIZATION_NOT_FOUND        = 'DeserializationError.NotFound';
export const DESERIALIZATION_VALIDATION_ERROR = 'DeserializationError.Validation';
export const DESERIALIZATION_SCHEMA_MISMATCH  = 'DeserializationError.SchemaMismatch';
export const DESERIALIZATION_UNIQUE_VIOLATION = 'DeserializationError.UniqueViolation';
export const RECAPTCHA_FAILED                 = 'Recaptcha.Failed';

// Restricted lesson related codes.
export const ERROR_LESSON_ACCESS_PENDING = 'RestrictedLesson.AccessPending';
export const ERROR_LESSON_ACCESS_EXPIRED = 'RestrictedLesson.AccessExpired';
export const ERROR_LESSON_TOKEN_INVALID  = 'RestrictedLesson.TokenInvalid';

// Error metadata
export const DESERIALIZATION_ATTRIBUTE_DISPLAY_NAME = 'display_name';
export const DESERIALIZATION_ATTRIBUTE_NAME = 'name';
export const DESERIALIZATION_ATTRIBUTE_EMAIL = 'email';
export const DESERIALIZATION_ATTRIBUTE_GENDER = 'gender';
export const DESERIALIZATION_ATTRIBUTE_RESET_TOKEN = 'reset_password_token';
export const DESERIALIZATION_DETAILS_ERROR_BLANK = 'blank';
export const DESERIALIZATION_DETAILS_ERROR_INVALID_DOMAIN = 'invalid_domain';
export const DESERIALIZATION_DETAILS_ERROR_INVALID_EMAIL = 'invalid_email';
export const DESERIALIZATION_DETAILS_ERROR_PASSWORD_RULE = 'password_rule';
export const DESERIALIZATION_DETAILS_ERROR_REQUIRED = 'required_for_completion';
export const DESERIALIZATION_DETAILS_ERROR_REQUIRES_ROMAN = 'requires_roman';
export const DESERIALIZATION_DETAILS_ERROR_TAKEN = 'taken';
export const DESERIALIZATION_DETAILS_ERROR_TOO_LONG = 'too_long';
export const DESERIALIZATION_DETAILS_ERROR_VALID_FROM = 'valid_from';

// Error metadata constraints
export const CONSTRAINT_BRAND_UNIQUE_CANONICAL_FALLBACK = 'index_brands_on_unique_canonical_fallback';

export const responseErrorHasCode = (responseError: unknown, errorCode: string): boolean =>
  responseError instanceof ApplicationError && responseError.error.code === errorCode;
